import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import editIcon from "../../../assets/images/Edit.svg";
import deleteIcon from "../../../assets/images/Delete.svg";
import DataTableChipAndTooltip from "../../../components/CommonReusableComponent/DataTableChipAndTooltip/DataTableChipAndTooltip";
import { getPlusSignInCountryCode } from "../../../common/CommonFunctions";
import { getRelativeRoleName } from "../../../config/Roles.config";
import { MuiDataGridStyle } from "../../../theme/App.theme";
import NoRecordsToDisplay from "../../../components/CommonReusableComponent/NoRecordsToDisplay/NoRecordsToDisplay";

const UserMasterDataTable_V2 = ({
  Rows,
  GetRowDataOnClickOfAction,
  PageSizeOptions,
  RowsToDisplay,
}) => {
  const plantMasterColumnsData = [
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 90,
      maxWidth: 90,
      renderCell: (param) => (
        <div className="d-flex justify-content-center align-items-center h-100 gap-3">
          <img
            src={editIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction("Update User", param.row);
            }}
          />
          <img
            src={deleteIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction("Delete User", param.row);
            }}
          />
        </div>
      ),
    },
    {
      field: "userName",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "roleName",
      headerName: "Role",
      sortable: false,
      width: 100,
      valueGetter: (value, row) => getRelativeRoleName(value)
    },
    {
      field: "branchName",
      headerName: "Branch Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "assignedDepartmentsForDataTable",
      headerName: "Departments",
      sortable: false,
      flex: 1,
      minWidth: 250,
      renderCell: (param) => <DataTableChipAndTooltip Data={param?.row["assignedDepartments"]} />,
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      sortable: false,
      flex: 1,
      minWidth: 170,
      valueGetter: (value, row) =>
        `${getPlusSignInCountryCode(row["phoneNumberContryCode"])} ${value}` ||
        "Not Available",
    },
    {
      field: "email",
      headerName: "Email",
      sortable: false,
      flex: 1,
      minWidth: 250,
    },
  ];

  return (
    <React.Fragment>
      <div className="w-100">
        <DataGrid
          columns={plantMasterColumnsData}
          rows={Rows}
          slots={{
            noRowsOverlay: NoRecordsToDisplay,
          }}
          pageSizeOptions={PageSizeOptions || [5, 10, 15, 25, 50]}
          initialState={{
            density: "compact",
            pagination: {
              paginationModel: {
                pageSize: RowsToDisplay || 10,
              },
            },
          }}
          disableRowSelectionOnClick
          density="compact"
          className="custom-data-grid"
          sx={MuiDataGridStyle}
        />
      </div>
    </React.Fragment>
  );
};

export default UserMasterDataTable_V2;
